export function enrichGeoPageview<T extends {
  event?: string;
  properties?: Record<string, unknown>;
} | null>(event: T): T {
  if (event?.event !== "$pageview") return event;
  const currentUrl = event.properties?.$current_url;
  if (typeof currentUrl !== "string") return event;
  let pathname: string;
  try { pathname = new URL(currentUrl).pathname; } catch { return event; }
  const match = /^\/buy-([a-z0-9-]+)\/([a-z-]+)(?:\/([a-z0-9-]+))?\/?$/.exec(pathname);
  if (!match) return event;
  return { ...event, properties: {
    ...event.properties,
    page_type: match[3] ? "city" : "state",
    product_slug: match[1],
    state: match[2],
    city: match[3] ?? null,
  } };
}

export interface GeoMarketView {
  page_type: "city" | "state";
  product_slug: string;
  state: string;
  city: string | null;
  tier: "state" | "local" | "nearby";
  displayed_own_listing_count: number;
  displayed_nearby_count: number;
  displayed_listing_count: number;
  indexable: boolean;
}
